.subtitle {
  font-size: 17px;
  color: var(--ps-text-secondary);
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.6;
  height: 28px;
  transition:
    opacity 0.5s ease,
    transform 0.5s ease,
    filter 0.5s ease;
}

.subtitleVisible {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}

.subtitleHidden {
  opacity: 0;
  transform: translateY(8px);
  filter: blur(4px);
}
